import { ComponentProps } from 'lib/component-props';
import EEPlaceholder from 'components/Sections/EEPlaceholder';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import {
  Field,
  GetStaticComponentProps,
  useComponentProps,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { slugToName } from 'model/Article';
import { defaultLanguage } from 'temp/config';
import { seriesArticlesService } from 'lib/services/SeriesArticles';

type DataBySeriesNameType = {
  id: string;
  name: string;
  template: {
    id: string;
  };
  seriesName: Field<string>;
  description: Field<string>;
  image: {
    src: string;
    alt: string;
  };
};

const ArticleSeriesBanner = ({ rendering }: ComponentProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const dataBySeriesName = useComponentProps<DataBySeriesNameType>(rendering.uid);

  const title = dataBySeriesName?.name;
  const description = dataBySeriesName?.description?.value;

  return !sitecoreContext.pageEditing ? (
    <section
      data-e2e-component-uid={rendering.uid}
      className="default-section-padding background-white"
    >
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-8 col-lg-9">
            <h1 className="line-clamp-2">{title}</h1>
            <p className="body-large mt-2 text-grey line-clamp-3">{description}</p>
          </div>
        </div>
      </div>
    </section>
  ) : (
    <EEPlaceholder>Article Series Banner</EEPlaceholder>
  );
};

export const getStaticProps: GetStaticComponentProps = async (rendering, layoutData, context) => {
  const seriesName = slugToName(context.params?.path?.at(-1));
  const language = layoutData.sitecore.context.language ?? defaultLanguage;
  const dataBySeriesName = await seriesArticlesService.getSeriesBanner(language, seriesName);

  return dataBySeriesName;
};

export default ArticleSeriesBanner;
